import React, { Component  } from 'react'

class RasterAd extends Component {

    componentDidMount() {
     (window.adsbygoogle = window.adsbygoogle || []).push({})
    }

   render () {
    return(
        <div style={{textAlign: 'center'}}>

        <span style={{color: 'grey'}}>Advertisement</span>
            <ins className = "adsbygoogle"
                data-ad-client="ca-pub-3602432664279609"
                 data-ad-slot="7024061398">
            </ins>
        </div>)
    }
}

export default RasterAd